import { useEffect, useState } from 'react';
const useDebouncedValue = (value, delayMs) => {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delayMs);
        return () => clearTimeout(timer);
    }, [value, delayMs]);
    return debounced;
};
export default useDebouncedValue;
